import Modal from '@/customComponents/uiComponents/modal/Modal.jsx'
import ModalHeader from '@/customComponents/uiComponents/modal/ModalHeader.jsx'
import {PayAfterDropoffContent} from '@/customComponents/BookRideSteps/modalPages/payAfterDropoff.jsx'

// Same content as the booking flow's payAfterDropoff step (carSelection /
// travelingDateTime); the trip-page Modal provides the padding.
export default function PayAfterDropoffPopup({isOpen, onClose}) {
    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalHeader title="" onClose={onClose}/>
            <PayAfterDropoffContent/>
        </Modal>
    )
}
